// A scene's runtime from the API's `durationSeconds`, which is null when the
// backend has no trustworthy value. Both helpers return null then, so callers
// leave the duration out instead of guessing.

const validSeconds = (seconds) =>
  Number.isFinite(seconds) && seconds > 0 ? Math.round(seconds) : null

// Whole minutes for copy ("31 minutes"), never below 1.
export const durationMinutes = (seconds) => {
  const total = validSeconds(seconds)
  return total === null ? null : Math.max(1, Math.round(total / 60))
}

// ISO 8601 for schema.org `duration` and `<time datetime>`: PT31M17S, or
// PT1H2M3S past the hour.
export const isoDuration = (seconds) => {
  const total = validSeconds(seconds)
  if (total === null) return null

  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const secs = total % 60
  return `PT${hours ? `${hours}H` : ""}${minutes}M${secs}S`
}
